import React from "react";
import Card from "react-bootstrap/Card";


function PartnerCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p className="about-text">
           At Choicest Fruit<span className="small-r-symbol">®</span>, we believe lasting change comes through collaboration. We welcome individuals and organizations 
           who share our values and commitment to building stronger, more connected neighborhoods and communities that benefit all of humanity. 
           We partner with people from all walks of life, community members, apartment complexes, schools, nonprofits, educators, and tech innovators, who share
            a desire to improve the world through action, creativity, and compassion.
          </p>

          <p className="about-text">
           <span className="purple">What Makes Us Different</span>
           <p>
           Unlike many companies that only seek out “like-minded” partners, Choicest Fruit values diversity of thought and experience. We encourage the independent investigation of truth, seeing and hearing with one’s own eyes and ears, rather than simply echoing others.
           Our collaborations are built on unity, respect, and shared purpose. We don’t expect identical views; instead, we focus on working together toward positive goals that uplift humanity.
          </p>
          </p>              
          
          <footer className="blockquote-footer"></footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default PartnerCard;
